import { sanitize } from 'dompurify';
import { observer } from 'mobx-react-lite';
import { useTranslationsContext } from 'store/translations';

interface Props {
    isRawHtml?: boolean;
    of: string;
    fallback?: string;
    params?: Record<string, string | number>;
}

const Label = observer(({ isRawHtml, of, fallback, params }: Props) => {
    const { translate } = useTranslationsContext();

    const content = translate(of, params, fallback);

    /* eslint-disable react/no-danger */
    return isRawHtml ? <span dangerouslySetInnerHTML={{ __html: sanitize(content) }} /> : <>{content}</>;
    /* eslint-enable react/no-danger */
});

export default Label;
